module.exports = __webpack_public_path__ + "img/heading-text.d3a5199e.png";